import React from 'react';
import type { ButtonProps } from '@stitch-fix/mode-react';
import { Button } from '@stitch-fix/mode-react';
import { useSelectEvent } from '@stitch-fix/event-reporter';
export interface GetStartedButtonProps extends ButtonProps<'a'> {
  eventLocation: 'hero' | 'page_end';
  href?: string;
  copy?: string;
}
export const GetStartedButton = ({
  href = '/signup',
  copy,
  eventLocation,
  ...rest
}: GetStartedButtonProps) => {
  const {
    reportSelectEvent
  } = useSelectEvent();
  const copyTitle = copy ?? 'Get started';
  const handleButtonClick = () => {
    if (href === '/signup') {
      reportSelectEvent({
        action_name: 'navigate_to_signup',
        content_id: eventLocation,
        name: 'take_style_quiz_button',
        schema: 'select'
      });
    }
  };
  return <Button as="a" href={href} onClick={handleButtonClick} {...rest}>
      {copyTitle}
    </Button>;
};